module.exports = __webpack_public_path__ + "static/media/TOP_PROMOTIONS.d3fced87.png";